// Import all icons from @ant-design/icons
import * as AntDesignIcons from '@ant-design/icons';

// Import all Lucide icons
import * as LucideIcons from 'lucide-react';

// Import all custom icons
import * as CustomIcons from '../icons';

// Merge all icon sets
const Icons = {
  ...AntDesignIcons,
  ...LucideIcons,
  ...CustomIcons,
};

export default Icons;
